const Icon = ({width, height}) => {

  return (
    <svg width="25" height="49" viewBox="0 0 25 49">
      <path opacity="0.1" d="M19.4401 0H24.2001L4.88012 49H0.120117L19.4401 0Z" fill="white"/>
    </svg>
  );
};
export default Icon;
